/* eslint-disable */
import $ from 'jquery';
export default function scrollTo($e) {
  var $e = $($e), $nav = $('.navbar-fixed-top');
  if (!$e || $e.length < 1 || !$nav || $nav.length < 1) {
    return;
  }
  var offset = $e.offset();
  if (!offset) {
    return;
  }
  var navBarHeight = $nav.css('position') == 'absolute' ? 0 : 0 + $nav.outerHeight(), top = offset.top - navBarHeight, newTop = top < 0 ? 0 : top;
  window.scrollTo(0, newTop);
}

